import React, { useEffect, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { logReportAction, masterActions } from "../../_store";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import Table from "../../components/common/table/Table";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../components/common/export/generateXlsx";
import CustomLoader from "../../components/common/ui/Loader";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";

const IrrelevantPODAccess = () => {
  const {
    facilityDropDown,
    logHistorFirstName,
    logHistoryLastName,
    GetPodList,
  } = useSelector((x) => x.master);

  const {
    irrelevant,
    invalidLogReportList,
    inmateinvalidLogDetails,
    invalidLogReportFullList,
    loading,
  } = useSelector((x) => x.logReport);

  let IrrelevantSearch = { ...irrelevant };

  const [logDetails, setLogDetails] = useState({
    FacilityID: 0,
    PodID: 0,
    InmateResidentID: "",
    FromDate: "",
    ToDate: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  const [showSearchFields, setShowSearchFields] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    handleReset();
  }, []);

  //Load Facility dropdown List
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);

  //
  useEffect(() => {
    dispatch(logReportAction.InmateInvalidLogReport(IrrelevantSearch));
  }, [IrrelevantSearch?.PageNo, IrrelevantSearch?.RowCountPerPage]);

  //Excel

  useEffect(() => {
    if (invalidLogReportFullList?.DataList?.length > 0) {
      const title = "IrrelevantPodAccess";
      const generateColumn = [
        "InmateID",
        "Inmate Full Name",
        "POD",
        "No of Attempt",
        "Last Login Attempt Date",
      ];

      const exportExcelData = invalidLogReportFullList?.DataList?.map(
        (obj) => ({
          InmateID: obj.InmateResidentId,
          InmateName: obj.InmateName,
          POD: obj.PodCode,
          AttemptCount: obj.AttemptCount,
          LastLogin: obj.LastLogin,
        })
      );

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(exportExcelData, generateColumn, title);
        dispatch(logReportAction.clearLogReportFullList());
      } catch (error) { }
    }
  }, [invalidLogReportFullList]);

  const handleSelectChange = (selectedOption, name) => {
    const loadGridList = () => {
      dispatch(
        logReportAction.InmateInvalidLogReport({
          ...IrrelevantSearch,
          PageNo: 1,
        })
      );
      dispatch(
        logReportAction.setIrrelevant({
          ...IrrelevantSearch,
          PageNo: 1,
          RowCountPerPage: 10,
        })
      );
    };

    const handleFacilityID = () => {
      IrrelevantSearch[name] = selectedOption?.value || 0;
      IrrelevantSearch.FirstNameValue = 0;
      IrrelevantSearch.UserFirstName = "";
      IrrelevantSearch.LastNameValue = 0;
      IrrelevantSearch.UserLastName = "";
      IrrelevantSearch.PodID = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: IrrelevantSearch[name],
          LastName: IrrelevantSearch?.UserLastName,
        })
      );
      dispatch(
        masterActions.GetInmateLastName({
          facilityID: IrrelevantSearch[name],
          firstName: IrrelevantSearch?.UserFirstName,
        })
      );
      dispatch(masterActions.GetPODList(IrrelevantSearch[name]));
      // dispatch()
      loadGridList();
    };

    const handlePod = () => {
      IrrelevantSearch[name] = selectedOption?.value || 0;
      loadGridList();
    };

    const handleFirstName = () => {
      IrrelevantSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      IrrelevantSearch.FirstNameValue = selectedOption?.value || "";

      dispatch(
        masterActions.GetInmateLastName({
          facilityID: IrrelevantSearch.FacilityID,
          firstName: IrrelevantSearch.UserFirstName,
        })
      );

      loadGridList();
    };

    const handleLastName = () => {
      IrrelevantSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      IrrelevantSearch.LastNameValue = selectedOption?.value || "";

      //Need clear the FiestName when i choose the Lastname
      IrrelevantSearch.UserFirstName = "";
      IrrelevantSearch.FirstNameValue = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: IrrelevantSearch?.FacilityID,
          LastName: IrrelevantSearch?.UserLastName,
        })
      );

      loadGridList();
    };

    switch (name) {
      case "FacilityID":
        handleFacilityID();
        break;

      case "PodID":
        handlePod();
        break;

      case "UserFirstName":
        handleFirstName();
        break;

      case "UserLastName":
        handleLastName();
        break;

      default:
        console.warn(`Unhandled field name: ${name}`);
    }

    // dispatch(logReportAction.setIrrelevant(IrrelevantSearch));
  };

  const handleDateChange = (value, name) => {
    const updatedState = { ...IrrelevantSearch };
    const date = fDate(value);
    updatedState[name] = date;
    dispatch(logReportAction.setIrrelevant(updatedState));
  };

  //Click the Enter Btn need to select the Current Date
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && IrrelevantSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "FromDate") {
      if (
        IrrelevantSearch.ToDate &&
        new Date(value) > new Date(IrrelevantSearch.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ToDate") {
      if (
        IrrelevantSearch.FromDate &&
        new Date(value) < new Date(IrrelevantSearch.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...IrrelevantSearch,
      FromDate:
        fieldName === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : IrrelevantSearch.FromDate, // preserve existing value
      ToDate:
        fieldName === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : IrrelevantSearch.ToDate, // preserve existing value
    };

    dispatch(logReportAction.setIrrelevant(updatedParam));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    IrrelevantSearch.InmateResidentID = value.replace(/\D/g, "");

    dispatch(logReportAction.setIrrelevant(IrrelevantSearch));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!IrrelevantSearch.FacilityID) {
      dispatch(logReportAction.clearinmateAccessReportList());
      Popup({
        title: "Message",
        text: `Select any one of the Facility Code in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    }

    dispatch(
      logReportAction.InmateInvalidLogReport({
        ...IrrelevantSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    dispatch(
      logReportAction.setIrrelevant({
        ...IrrelevantSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  const columns = [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Full Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      sortable: true,
    },
    {
      name: "POD",
      key: "PodCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      name: "No of Attempt",
      key: "AttemptCount",
      selector: (row) => row.AttemptCount,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          data-bs-toggle="modal"
          data-bs-target="#Login_Attempt"
          onClick={() => handleInmateInvalidLogDetails(row)}
        >
          {row.AttemptCount}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Last Login Attempt Date",
      key: "LastLogin",
      selector: (row) => row.LastLogin,
      sortable: true,
    },
  ];

  const LogDetailsColumn = [
    {
      width: "100px",
      name: "Kiosk Code",
      key: "KiosksCode",
      selector: (row) => row.KiosksCode,
      sortable: true,
    },
    {
      width: "150px",
      name: "Login Attempt Date",
      key: "LoginDate",
      selector: (row) => row.LoginDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row?.LoginDate}</div>
        </div>
      ),
      sortable: true,
    },
  ];

  //sorting
  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isSorting = true;
    const search = { ...irrelevant };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(logReportAction.setIrrelevant(search));

    dispatch(
      logReportAction.InmateInvalidLogReport({
        ...irrelevant,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //handleSortModal
  let isSortingModal = false; // to restrict the pagination issue
  const handleSortModal = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isSortingModal = true;
    const search = { ...logDetails };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;

    setLogDetails(search);
    dispatch(
      logReportAction.InmateInvalidLogDetails({
        ...logDetails,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //Pagination
  const handlePageChange = (value, name) => {
    if (name === "LogReportList") {
      if (isSorting) {
        isSorting = false;
        return;
      }
      const params = { ...IrrelevantSearch, PageNo: value };
      dispatch(logReportAction.setIrrelevant(params));
    } else if (name === "LogDetails") {
      if (isSortingModal) {
        isSortingModal = false;
        return;
      }
      setLogDetails((prev) => ({
        ...prev,
        PageNo: value,
      }));
    }
  };

  // Call API when page changes

  const handleRowPerPage = (value, name) => {
    if (name === "LogReportList") {
      const params = { ...IrrelevantSearch, RowCountPerPage: value, PageNo: 1 };
      dispatch(logReportAction.setIrrelevant(params));
    } else if (name === "LogDetails") {
      setLogDetails((prev) => ({
        ...prev,
        RowCountPerPage: value,
        PageNo: 1,
      }));
    }
  };

  //     dispatch(logReportAction.InmateInvalidLogDetails(params));

  //Load Modal dataList
  useEffect(() => {
    dispatch(logReportAction.InmateInvalidLogDetails(logDetails));
  }, [
    logDetails.PageNo,
    logDetails.RowCountPerPage,
    logDetails.InmateResidentID,
    logDetails.PodID,
  ]);

  const handleInmateInvalidLogDetails = (row) => {
    setLogDetails((prev) => ({
      ...prev,
      FacilityID: IrrelevantSearch.FacilityID,
      PodID: row.PodID,
      InmateResidentID: row.InmateResidentId,
      FromDate: IrrelevantSearch.FromDate,
      ToDate: IrrelevantSearch.ToDate,
    }));
  };

  const handleExcel = () => {
    let updatedParam = {
      ...IrrelevantSearch,
      PageNo: 1,
      RowCountPerPage: invalidLogReportList.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(logReportAction.InmateInvalidLogReport(updatedParam));
  };

  //Reset
  const handleReset = () => {
    dispatch(logReportAction.clearIrrelevant());
  };
  const handleResetPageandRowCount = () => {
    setLogDetails((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      PageNo: 1,
    }));
  };

  if (loading) {
    return <CustomLoader />;
  }
  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityDropDown}
                value={IrrelevantSearch?.FacilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FacilityID")
                }
                isMulti={false}
                isClearable={IrrelevantSearch?.FacilityID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                id="InmateResidentID"
                label="Inmate ID"
                value={IrrelevantSearch?.InmateResidentID}
                handleChange={handleChange}
                placeholder=""
                disabled={false}
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="UserLastName"
                label="Last Name"
                options={logHistoryLastName}
                value={IrrelevantSearch?.LastNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserLastName")
                }
                isMulti={false}
                isDisabled={!IrrelevantSearch?.FacilityID}
                isClearable={IrrelevantSearch?.LastNameValue ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="UserFirstName"
                label="First Name"
                options={logHistorFirstName}
                value={IrrelevantSearch?.FirstNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserFirstName")
                }
                isMulti={false}
                isDisabled={!IrrelevantSearch?.FacilityID}
                isClearable={IrrelevantSearch?.FirstNameValue ? true : false}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="FromDate"
              label="From Date"
              maxDate={
                IrrelevantSearch?.ToDate ? IrrelevantSearch?.ToDate : new Date()
              }
              minDate={new Date(2017, 0, 1)}
              value={IrrelevantSearch?.FromDate || null} // Ensure null when cleared
              handleChange={(date) => handleDateChange(date, "FromDate")}
              // required
              yearDropDown={true}
              clearable={true} // Pass clearable prop (modify DateInput if needed)
              handleBlur={(e) => handleDateBlur(e, "FromDate")}
              handleKeyDown={(e) => handleDateEnterKey(e, "FromDate")}
            />
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="ToDate"
              label="To Date"
              minDate={
                IrrelevantSearch?.FromDate
                  ? IrrelevantSearch?.FromDate
                  : new Date(2017, 0, 1)
              }
              maxDate={new Date()}
              value={IrrelevantSearch?.ToDate || null}
              handleChange={(date) => handleDateChange(date, "ToDate")}
              // required
              yearDropDown={true}
              clearable={true}
              // errorMessage={errorMessage}
              handleBlur={(e) => handleDateBlur(e, "ToDate")}
              handleKeyDown={(e) => handleDateEnterKey(e, "ToDate")}
            />
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                label="POD"
                options={GetPodList}
                value={IrrelevantSearch?.PodID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PodID")
                }
                isDisabled={IrrelevantSearch.FacilityID === 0 ? true : false}
                isMulti={false}
                isClearable={IrrelevantSearch?.PodID ? true : false}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        {/* <div className="mb-2">
          <h2 className="form_title_uppercase text-color">
            Irrelevant Pod Access Search
          </h2>
        </div> */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">
              Irrelevant Pod Access Search
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">
            Irrelevant Pod Access Search
          </h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-5">
        {/* Display a message if FacilityID is not selected */}
        {IrrelevantSearch.FacilityID === 0 ? (
          <div className="text-center">
            <b className="table-no-data-text mt-5 fs-4 mb-5">
              Select any one of the Facility Code in the dropdown list
            </b>
          </div>
        ) : (
          <>
            {/* Export and Table Section */}
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
              <h2 className="form_title_uppercase text-color">
                Irrelevant Pod Access LIST
              </h2>
              {/* Show Excel export button if data is available */}
              {invalidLogReportList?.DataList?.length > 0 && (
                <ExcelExport handleExcelExport={handleExcel} />
              )}
            </div>

            {/* Data Table */}
            <Table
              columns={columns}
              data={invalidLogReportList?.DataList}
              pagination={true}
              onChangePage={(e) => handlePageChange(e, "LogReportList")} // Call API when page changes
              onChangeRowsPerPage={(e) => handleRowPerPage(e, "LogReportList")}
              totalRowCount={invalidLogReportList?.TotalRecordCount}
              currentPage={IrrelevantSearch?.PageNo}
              paginationPerPage={IrrelevantSearch?.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={IrrelevantSearch?.SortField?.split(" ")[0]}
              sortDirection={IrrelevantSearch?.SortField?.split(" ")[1]}
            />

            {/* Common Modal for Login Attempt Details */}
            <CommonModal
              modalId="Login_Attempt"
              title="INMATE LOGIN ATTEMPT DETAILS"
              loader={inmateinvalidLogDetails.loading}
              handleCloseIcon={handleResetPageandRowCount}
              bodyContent={
                <Table
                  title={""}
                  columns={LogDetailsColumn}
                  data={inmateinvalidLogDetails?.DataList}
                  pagination={true}
                  onChangePage={(e) => handlePageChange(e, "LogDetails")} // Call API when page changes
                  onChangeRowsPerPage={(e) => handleRowPerPage(e, "LogDetails")} // Handle rows per page change
                  totalRowCount={inmateinvalidLogDetails?.TotalRecordCount}
                  currentPage={logDetails?.PageNo}
                  paginationPerPage={logDetails?.RowCountPerPage}
                  serverSideSort
                  onSort={handleSortModal}
                  sortColumn={logDetails?.SortField?.split(" ")[0]}
                  sortDirection={logDetails?.SortField?.split(" ")[1]}
                />
              }
              footerContent={
                <button
                  className="btn button-primary"
                  onClick={() => {
                    handleResetPageandRowCount();
                  }}
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(IrrelevantPODAccess);
